__turbopack_context__.v({
  "block": "IvLoungeRevivSection-module__FeYiNW__block",
  "paragraphs": "IvLoungeRevivSection-module__FeYiNW__paragraphs",
  "revivWordmark": "IvLoungeRevivSection-module__FeYiNW__revivWordmark",
  "shell": "IvLoungeRevivSection-module__FeYiNW__shell",
  "statGroup": "IvLoungeRevivSection-module__FeYiNW__statGroup",
  "statLabel": "IvLoungeRevivSection-module__FeYiNW__statLabel",
  "statValue": "IvLoungeRevivSection-module__FeYiNW__statValue",
  "statsRow": "IvLoungeRevivSection-module__FeYiNW__statsRow",
});
